<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <Breadcrumbs :items="breadcrumbs" />
    </v-flex>

    <v-flex xs12>
      <v-flex xs12 md3>
        <v-select
          v-model="statusSelected"
          :items="status"
          label="Estado"
          outline
          @change="getTickets(statusSelected)"
        ></v-select>
      </v-flex>
    </v-flex>

    <v-flex xs12 md8 class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex xs12 md12 v-for="(ticket, i) in tickets" :key="i" class="pointer" @click="goTo(ticket.id)">
          <v-card class="hc__rounded-card">
            <v-card-text class="mb-1">
              <v-layout row wrap>
                <v-flex xs10 md10>
                  <p class="ma-0 hc__blue-text"># {{ ticket.id }} - {{ ticket.category }}</p>
                  <p>Creado: {{ ticket.created_at }}</p>
                </v-flex>
                <v-flex xs2 md2>
                  <p :class="`ma-0 ${statusColor(ticket.status)}`">
                    <v-icon :class="statusColor(ticket.status)">{{ statusIcon(ticket.status) }}</v-icon>
                    {{ ticket.status }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapActions } from 'vuex';
import Breadcrumbs from "@/components/Helpcenter/Breadcrumbs"

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    breadcrumbs: [
      { to: "/", text: "Inicio", disabled: false, exact: true },
      { to: "/centro-de-ayuda", text: "Centro de ayuda", disabled: false, exact: true },
      { to: "", text: "Mis casos", disabled: true }
    ],
    status: ["Todos", "Creado", "En atención", "Resuelto"],
    statusSelected: "Todos",
    tickets: []
  }),
  methods: {
    ...mapActions("helpcenter", ["fetchTickets"]),
    async getTickets(status = "Todos") {
      const res = await this.fetchTickets(status)
      this.tickets = res
    },
    goTo(id) {
      this.$router.push(`/centro-de-ayuda/mis-casos/${id}`)
    },
    statusIcon(status) {
      if (status === "Creado") return "history"
      else if (status === "En atención") return "cached"
      else return "done"
    },
    statusColor(status) {
      if (status === "Creado") return "hc__color-open"
      else if (status === "En atención") return "hc__color-attended"
      else return "hc__color-close"
    }
  },
  created() {
    this.getTickets()
  }
}
</script>
<style lang="css">
.hc__rounded-card{
  border-radius: 0.5rem;
}


.hc__color-open {
  color:#E8114b !important
}

.hc__color-attended {
  color: #2196f3 !important
}

.hc__color-close {
  color:#4caf50 !important
}
</style>